<template>
  <div>
    <CardedDisplay>
      <PlainDisplay :show_icon="false">
        <PromotionHeader
          :is_loading="is_loading"
          :promotion="promotion"
          :is_owner_view="is_owner_view"
          :is_in_admin_view="is_in_admin_view"
        ></PromotionHeader>
      </PlainDisplay>
    </CardedDisplay>
    
    <CardedSectionHeader
      icon="mdi-power"
      label="End Concent Form"
      id="owner_end_promotion_section"
    >
        <v-btn
        @click="$router.go(-1)"
        small
        rounded
        class="mr-4"
        outlined
        color="default"
      >
        <v-icon left>mdi-cancel</v-icon> Cancel Ending
      </v-btn>
    </CardedSectionHeader>
    <CardedForm
      ref="owner_end_promotions_form_ref"
      id="owner_end_promotions_form"
      title="_"
      :is_loading="is_loading || parseInt(promotion.has_been_ended) == 1"
      @on-submit-form="update_promotion"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
      submit_btn_text="End Now"
      submit_btn_color="red"
    >
      <v-alert dense text type="warning" v-if="parseInt(promotion.has_been_ended) == 0">
        Your are about to mark this promotion as ended <br />
        <strong> Click The End Now Button</strong>, if you are sure.
      </v-alert>
      <v-alert dense text type="error" v-if="parseInt(promotion.has_been_ended) == 0" >
        Please note that <br />
        <strong> This action can not be reversed</strong>, please be sure
      </v-alert>

      <v-alert dense text type="error" v-if="parseInt(promotion.has_been_ended) == 1" >
        Please note that <br />
        <strong> This promotion is already marked ended</strong>
      </v-alert>

      <template v-slot:clearbtnslot>
        <p class="black--text text-left text-h6"></p>
      </template>
    </CardedForm>
  </div>
</template>


<script>
import ServerClient from "../../../lib/ServerClient";
import CardedDisplay from "./../../../components/CardedDisplay";
import PlainDisplay from "./../../../components/PlainDisplay";
import PromotionHeader from "./../../../components/PromotionHeader";
import CardedForm from "./../../../components/CardedForm";
import CardedSectionHeader from "./../../../components/CardedSectionHeader";
import Utils from "../../../lib/Utils";
export default {
  name: "OwnerPromtionsEnd",
  components: {
    CardedDisplay,
    PlainDisplay,
    PromotionHeader,
    CardedForm,
    CardedSectionHeader,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_owner_view: {
      type: Boolean,
      default: true,
    },
    is_in_admin_view: {
      type: Boolean,
      default: false,
    },
    is_in_public_view: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      promotion_id: 0,
      promotion: Utils.get_default_promotion(),
      is_owner: false,
      errors: [],
      message: "",
    };
  },
  methods: {
    on_auto_fill() {
      //no need for this method here
    },
    load_promotion() {
      this.$emit("on-show-loader");
      ServerClient.Promotions.get_promotion(
        {
          id: this.promotion_id,
          get_header_only: true,
        },
        (res) => {
          this.$emit("on-hide-loader");
          //   console.log("This one ", res);
          var php_time_now = parseFloat(Utils.date_str_to_php_time(""));
          res.expiry = "";
          if (php_time_now < parseFloat(res.starts_on_timestamp)) {
            res.expiry = "pending";
          } else if (
            php_time_now >= parseFloat(res.starts_on_timestamp) &&
            php_time_now <= parseFloat(res.ends_on_timestamp)
          ) {
            res.expiry = "live";
          } else if (php_time_now > parseFloat(res.ends_on_timestamp)) {
            res.expiry = "expired";
          }

          this.promotion = res;
          if (
            this._user &&
            this._user != null &&
            this.promotion.business &&
            parseInt(this._user.id) == parseInt(this.promotion.business.user_id)
          ) {
            this.is_owner = true;
          }
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading prmomotion details on owners promotion end view",
            errors
          );
        }
      );
    },
    update_promotion() {
      this.errors = [];
      this.message = "";
      this.$emit("on-show-loader");
      ServerClient.Promotions.update_promotion(
        {
          data: {
            has_been_ended: 1,
            has_ended_automatically: 0,
            _data_ended_on: "",
            _now_ended_on_timestamp: "",
          },
          id: this.promotion_id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.message =
            "<b>Operation was successfull</b> <br/>  Your promotion has been marked ended successfully";
          this.$refs.owner_end_promotions_form_ref.show_message_dialog();
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.errors = errors;
          this.$refs.owner_end_promotions_form_ref.show_error_dialog();
        }
      );
    },
    on_hide_message() {
      this.load_promotion();
    },
  },
  mounted() {
    this.promotion_id = parseInt(this.$route.params.id);
    this._user = ServerClient.Login.get_logged_in_user();

    this.$emit("set-page-attributes", {
      title: "End Promotion",
      crumps: [
        {
          text: "Owner",
          disabled: false,
          href: "/owner",
        },
        {
          text: "Promotions",
          disabled: false,
          href: "/owner/promotions",
        },
        {
          text: "List",
          disabled: false,
          href: "/owner/promotions/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/owner/promotions/list/view/" + this.promotion_id,
        },
        {
          text: "End",
          disabled: true,
          href: "/owner/promotions/list/view/" + this.promotion_id + "/end",
        },
      ],
      navbar_cols: 3,
    });
    this.load_promotion();

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#owner_end_promotion_section", options);
  },
};
</script>